const state = {
  agentRegObj:null,
  countryReq:null,
  countryRes:null,
  captchaRes:null,
  agentRegReq:null,
  agentRegRes:null
}

// getters
const getters = {
  GET_AGENCY_DET: () =>{
     return state.agentRegObj;
 },
 GET_AGENCY_REQ: () =>{
  return state.agentRegReq;
},
GET_AGENCY_RES: () =>{
  return state.agentRegRes;
},
 GET_COUNTRY_REQ: () =>{
  return state.countryReq;
},
GET_COUNTRY_RES: () =>{
  return state.countryRes;
},
GET_CAPTCHA_RES: () =>{
  return state.captchaRes;
},
}

// actions
 const actions = {
  CLEAR_AGT_REG_STORE({ commit }) {
    commit("clearAgtReg");
},
  SET_AGENCY_DET ({ commit }, agency) {
         commit('saveDetails',agency);    
    },
    SET_AGENCY_REQ ({ commit }, agencyReq) {
      commit('getAgencyReq',agencyReq);    
 },
 SET_AGENCY_RES ({ commit }, agencyRes) {
  commit('getAgencyRes',agencyRes);    
},
    SET_COUNTRY_REQ ({ commit }, req) {
      commit('getCountryReq',req);
    },
  SET_COUNTRY_RES ({ commit }, res) {
     commit('getCountryRes',res);  
},
SET_CAPTCHA_RES ({ commit }, res) {
 commit('getCaptchaRes',res);  
}
  }

// mutations
const mutations = {
  clearAgtReg(state) {
    state.agentRegObj = null;
    state.countryReq = null;
    state.countryRes = null;
    state.captchaRes = null;
    state.agentRegReq = null;
    state.agentRegRes = null;
},
  saveDetails (state, agency) {
    state.agentRegObj = agency
  },
  getAgencyReq (state, agencyReq) {
    state.agentRegReq = agencyReq
  },
  getAgencyRes (state, agencyRes) {
    state.agentRegRes = agencyRes
  },
  getCountryReq (state, req) {
    state.countryReq = req
  },
  getCountryRes (state, res) {
    state.countryRes = res
  },
  getCaptchaRes (state, res) {
    state.captchaRes = res
  },
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
